// redux
import { useSelector } from 'react-redux'
// router
import { Route, Redirect } from 'react-router-dom'
// services
import AuthService from '../../../modules/Auth/services/auth'
// main routes
import { currentHome } from '../../organisms/nav-menu/nav-menu-routes'

const PublicRoute = ({ component: Component, ...rest }) => {
	// redux
	const {
		session: { isLogin }
	} = useSelector(state => state)

	return (
		<Route
			{...rest}
			render={props =>
				!isLogin || !AuthService.isLoggedIn() ? (
					<Component {...props} />
				) : (
					<Redirect to={currentHome} />
				)
			}
		/>
	)
}

export default PublicRoute
